__turbopack_context__.v({
  "wrapper": "mvPVCG_wrapper",
  "wrapperLoading": "mvPVCG_wrapperLoading",
});
